import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LogIn from '../views/LogIn'
import SelectApp from '../views/SelectApp'
import ConfigureSettings from '../views/ConfigureSettings'
import MigRation from '../views/MigRation'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/login',
        name: 'LogIn',
        component: LogIn
    },
    {
        path: '/selectapp',
        name: 'SelectApp',
        component: SelectApp
    },
    {
        path: '/setting',
        name: 'ConfigureSettings',
        component: ConfigureSettings
    },
    {
        path: '/migration',
        name: 'MigRation',
        component: MigRation
    },

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
